import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHead = ({ 
  title = "immoriya Projektentwicklung GmbH",
  description = "Ihre strategische Immobilien-Holding in Osnabrück. Projektentwicklung, energetische Sanierung, Immobilienhandel und Verwaltung.",
  canonical,
  image = "https://customer-assets.emergentagent.com/job_gruppe-osnabrueck/artifacts/tyz0xdgq_ich.jpeg",
  type = "website"
}) => {
  const fullTitle = title.includes('immoriya') ? title : `${title} | immoriya Projektentwicklung GmbH`;
  
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      {image && <meta property="og:image" content={image} />}
      {canonical && <meta property="og:url" content={canonical} />}
      <meta property="og:locale" content="de_DE" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}
      
      {/* Canonical */}
      {canonical && <link rel="canonical" href={canonical} />}
    </Helmet>
  );
};

export default SEOHead;
